module.exports = __webpack_public_path__ + "static/media/bells_call.7d6e99a9.mp3";